import React from 'react';
import styled from 'styled-components';

import type { Me } from '@crehana/web';
import { ClientSideComponent } from '@crehana/web';

import Media from 'Jsx/Shared/ui/Media';
import CatalogAcademies from 'Jsx/Catalog/components/CatalogAcademies';

import SliderHeader from '../SliderHeader';

import CommunityRecommended from './components/CommunityRecommended';
import CommunityNew from './components/CommunityNew';

const ContentWrapper = styled.main`
  ${props => props.theme.breakpoints.up('lg')} {
    width: calc(100% - 312px);
  }

  & > div:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[40]};
  }
`;

interface LandingV2Props {
  me?: Me;
}

const LandingV2: React.FC<LandingV2Props> = ({ me }) => {
  const isPremium = !!me?.isPremium;
  const isPremiumTrial = !!me?.isPremiumTrial;
  const shouldRenderAcademiesSection = isPremium && !isPremiumTrial;

  return (
    <ContentWrapper className="flex-1 w-full mx-auto my-0 lg:m-0">
      <Media from="md" defaultMatches>
        <SliderHeader className="hidden mb-40 md:block" />
      </Media>

      <CommunityRecommended />

      <CommunityNew />

      {shouldRenderAcademiesSection && (
        <ClientSideComponent>
          <CatalogAcademies sourceDetail="Results" />
        </ClientSideComponent>
      )}
    </ContentWrapper>
  );
};

export default LandingV2;
